



import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSiteEventGetMarkerContent, GetSiteEventGetMarkerContentResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetSiteEventGetMarkerContentResponse, GetSiteEventGetMarkerContentResponse>) => response?.data?.siteEventMarker;
const getError = (response?: SWRResponse<GetSiteEventGetMarkerContentResponse, GetSiteEventGetMarkerContentResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetSiteEventGetMarkerContentResponse, GetSiteEventGetMarkerContentResponse>) => ({});

const useGetSiteEventGetMarkerContent = (query?: Partial<GetSiteEventGetMarkerContent>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query || !query.id) {
            return undefined;
        }

        return () => {
            return new GetSiteEventGetMarkerContent(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSiteEventGetMarkerContent;